import React, { Component } from 'react';
import './Timeline.css';
import { CompanyJobfairInfo, stallMap } from '../stallMapData_2026';

class Timeline extends Component {

  componentDidMount() {
    this.scrollToSectionFromHash();
  }

  componentDidUpdate() {
    this.scrollToSectionFromHash();
  }

  scrollToSectionFromHash = () => {
    if (window.location.hash !== '#workshops') {
      return;
    }

    const workshopsSection = document.getElementById('workshops');
    if (!workshopsSection) {
      return;
    }

    workshopsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  render() {
    // Function to create the companyNumbers object dynamically
    const createCompanyNumbers = (stallMap: Map<number, CompanyJobfairInfo>): { [key: string]: number | string } => {
      const companyNumbers: { [key: string]: number | string } = {};
      stallMap.forEach((companyInfo) => {
        // Check if stallNumber is not null before assigning it
        if (companyInfo.stallNumber !== null) {
          companyNumbers[companyInfo.companyName] = companyInfo.stallNumber;
        } else {
          // Optionally, assign a default value or skip
          companyNumbers[companyInfo.companyName] = 0; // For example, 0 for missing stall number
        }
      });
      return companyNumbers;
    };
    // Call the function to generate the object
    const companyNumbers = createCompanyNumbers(stallMap);
    // Define the table rows (without separate row variables, inside JSX)
    const rows = [
      {
        time: "10:00-11:00",
        companies: ["ÚJV Řež", "KPMG", "ABB"]
      },
      {
        time: "11:00-12:00",
        companies: ["ABB", "IVECO", "ÚJV Řež"]
      },
      {
        time: "12:00-13:00",
        companies: ["Vodafone", "KPMG", "Ernst & Young"]
      },
      {
        time: "13:00-14:00",
        companies: ["Ernst & Young", "ABB", ""]
      },
      {
        time: "14:00-15:00",
        companies: ["Vodafone", "IVECO", "MANN+HUMMEL"]
      }
    ];

    return (
      <div className='main-content'>
        <div className='pt-40 text-center'>
          <h1 className="font-bold mb-4 text-center text-[#1b75bb]">Program veletrhu</h1>
          {/* <p className="text-lg text-center mb-4">
              Program veletrhu již připravujeme!
            </p> */}

          <div>
            <section className="container pb-0">

              <p className="text-justify">
                Veletrh iKariéra <strong>začíná v 9:00</strong> hodin a končí odpoledne. Vyhodnocení soutěže proběhne ve <strong>14:00</strong> hodin.
                Kromě široké nabídky firem jsme pro tebe připravili i bohatý doprovodný program. Můžeš se těšit na:
              </p>
              <ul className="mt-4 space-y-2 list-none sm:ml-8">
                <li className="flex items-center gap-2 pl-4">
                  <span>⚽</span> Bodyzorbing – zábava v nafukovacích koulích
                </li>
                <li className="flex items-center gap-2 pl-4">
                  <span>💄</span> Kosmetika od Mary Kay
                </li>
                <li className="flex items-center gap-2 pl-4">
                  <span>🏥</span> Zdravotnická osvěta od organizace IFMSA
                </li>
                <li className="flex items-center gap-2 pl-4">
                  <span>⚡</span> Energetická vzpruha od Red Bullu
                </li>
                <li className="flex items-center gap-2 pl-4">
                  <span>🧑‍💼</span> Karierní poradenství
                </li>
                <li className="flex items-center gap-2 pl-4">
                  <span>🛠️</span> Workshopy
                </li>
              </ul>
            </section>

            <section className="container pb-0">
              <h3 className='text-justify text-[#1b75bb]'>Kariérní poradenství</h3>
              <p className='text-justify'> 
                Pomůžeme ti vylepšit tvoje profesní dokumenty, jako je CV a profil na LinkedInu, aby byly atraktivní pro potenciální zaměstnavatele.
                Na místě budou odborníci, kteří ti rádi poradí a doporučí, jak zaujmout.
              </p>
              <div className="d-flex justify-content-center align-items-center w-100 p-0" style={{ justifyContent: 'center' }}>
                <table className="col-11 mx-auto" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                  <thead>
                    <tr>
                      <th className="w-25 text-center">Čas</th>
                      <th className="w-25 text-center">Konzultace CV</th>
                      <th className="w-25 text-center">Konzultace CV</th>
                      <th className="w-25 text-center">Konzultace LinkedIn</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td className="w-25">{row.time}</td>
                        {row.companies.map((company, index) => {
                          // Find the company number using the partial match
                          const companyNumber = Object.keys(companyNumbers).find(companyName =>
                            companyName.toLowerCase().includes(company.toLowerCase())
                          );

                          // If we find a company number, get it from companyNumbers
                          const companyNumberValue = companyNumber ? companyNumbers[companyNumber] : null;

                          return (
                            <td key={index} className="w-25 cursor-pointer">
                              <a
                                href={`/plan?number=${companyNumberValue}`}
                                className="block no-underline text-white"
                              >
                                {company}
                              </a>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>

            <section id="workshops" className='container scroll-mt-32'>
              <h3 className="text-justify text-[#1b75bb] mt-5 mb-3">Workshopy</h3>
              <p className="my-4 text-justify">
                Workshopy se budou konat v <a href="/plan" className="font-bold text-[#1b75bb] underline hover:text-[#155a8a]">přednáškové učebně P381</a>. Pro víc informací o společnosti klikni na logo.
              </p>
              {/* <h4 className="text-center text-[#1b75bb] mt-3 mb-3">Pro víc informací o společnosti klikni na logo!</h4> */}

              <div className="row row-cols-1 row-cols-md-3 g-4">
                <div className="col"> {/* FIRST WORKSHOP */}
                  <div className="card shadow-sm pt-0 px-0 mb-5 bg-white rounded d-flex flex-column h-100">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <span className="time d-flex align-items-center">
                        <img src="/static/icons/clock.svg" alt="Clock Icon" className="mr-2 mb-0" />
                        10:00-10:50
                      </span>
                      <span className="text-right d-flex align-items-center">
                        <img src="/static/icons/location.svg" alt="Location Icon" className="mr-2 mb-0" />
                        P381
                      </span>
                    </div>
                    <div className="logo-container d-flex justify-content-center align-items-center pt-4 flex-grow-1">
                      <a href="/plan?number=22" className="transition-transform duration-300 transform hover:scale-100 scale-90 flex justify-center items-center mb-0">
                        <img src="/data/logos/ThreatMark.jpg" alt="image3" className="max-w-full h-auto" style={{ maxWidth: '80%' }} />
                      </a>
                    </div>
                    <div className="card-body pt-0 pb-0 workshop-card-body">
                      <h5 className="card-title">V mysli podvodníka</h5>
                      <p className="card-text text-muted">Interaktivní workshop, který vám ukáže bankovní bezpečnost z opačné strany. Nahlédnete do myšlení útočníka, odhalíte slabá místa a vyzkoušíte si hledat cesty tam, kde je ostatní nevidí.</p>
                    </div>
                  </div>
                </div>
                <div className="col"> {/* SECOND WORKSHOP */}
                  <div className="card shadow-sm pt-0 px-0 mb-5 bg-white rounded d-flex flex-column h-100">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <span className="time d-flex align-items-center">
                        <img src="/static/icons/clock.svg" alt="Clock Icon" className="mr-2 mb-0" />
                        13:00-13:50
                      </span>
                      <span className="text-right d-flex align-items-center">
                        <img src="/static/icons/location.svg" alt="Location Icon" className="mr-2 mb-0" />
                        P381
                      </span>
                    </div>
                    <div className="logo-container d-flex justify-content-center align-items-center pt-4 flex-grow-1">
                      <a href="/plan?number=13" className="transition-transform duration-300 transform hover:scale-100 scale-90 flex justify-center items-center mb-0">
                        <img src="/static/lineup/mann.jpg" alt="image3" className="max-w-full h-auto" style={{ maxWidth: '80%' }} />
                      </a>
                    </div>
                    <div className="card-body pt-0 pb-0 workshop-card-body">
                      <h5 className="card-title">Změň svůj mindset při hledání práce</h5>
                      <p className="card-text text-muted">Získej náskok před ostatními. Na tomto workshopu se dozvíš, jak přemýšlet strategicky o své kariéře, vyhnout se nejčastějším chybám a uspět u výběrových řízení. Lektorka vychází z 20 let zkušeností v recruitmentu a více než 10 let praxe v kariérním poradenství</p>
                    </div>
                  </div>
                </div>
                <div className="col"> {/* THIRD WORKSHOP */}
                  <div className="card shadow-sm pt-0 px-0 mb-5 bg-white rounded d-flex flex-column h-100">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <span className="time d-flex align-items-center">
                        <img src="/static/icons/clock.svg" alt="Clock Icon" className="mr-2 mb-0" />
                        15:00-15:50
                      </span>
                      <span className="text-right d-flex align-items-center">
                        <img src="/static/icons/location.svg" alt="Location Icon" className="mr-2 mb-0" />
                        P381
                      </span>
                    </div>
                    <div className="logo-container d-flex justify-content-center align-items-center pt-4 flex-grow-1">
                      <a href="/plan?number=46" className="transition-transform duration-300 transform hover:scale-100 scale-90 flex justify-center items-center mb-0">
                        <img src="/data/images/IAESTE_LC Brno.svg" alt="image3" className="max-w-full h-auto" style={{ maxWidth: '80%' }} />
                      </a>
                    </div>
                    <div className="card-body pt-0 pb-0 workshop-card-body">
                      <h5 className="card-title">Práce a zážitky v zahraničí</h5>
                      <p className="card-text text-muted">Na tomto workshopu uslyšíš zkušenosti studentů, kteří vycestovali na zahraniční stáž s IAESTE. Dozvíš se, jak stáž probíhá, co ti může přinést a proč se vyplatí zapojit i do spolku IAESTE. Přijď se inspirovat a zjistit, kam až tě může posunout vlastní cesta do zahraničí.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* <section className='container'>
              <ul>
                <li>
                  <h3 className='text-justify text-[#1b75bb]'>Kariérní poradenství</h3>

                  <div className="text-justify cv-container my-1">
                    <div className="row">
                      <p>
                        Pomůžeme ti vylepšit tvoje profesní dokumenty, jako je CV a profil na LinkedInu, aby byly atraktivní pro potenciální zaměstnavatele.
                        Na místě budou odborníci, kteří ti rádi poradí a doporučí, jak zaujmout.
                      </p>
                       <div className="photo-container col-12 col-md-3">
                        {this.photos.map((photo, index) => (
                          <div className="col-md-12 col-12 mb-3" key={index}>
                            <img src={photo.src} alt={`Timeline Photo ${index}`} className="img-fluid" />
                          </div>
                        ))}
                      </div>
                      
                      <div className="table-container col-12 col-md-9 row">
                        <div className="col-12 text-left reasons">
                          <ul>
                            <li>
                              <strong>Profesionální profilová fotografie:</strong>
                              <p>
                                Přímo na veletrhu budeš mít jedinečnou možnost nechat si zdarma pořídit profesionální profilovou fotografii.
                                Zkušený fotograf s bílým plátnem se postará o kvalitní snímek, který skvěle doplní tvůj LinkedIn profil či životopis.
                                Profesionální fotka ti pomůže udělat lepší první dojem na potenciální zaměstnavatele.
                              </p>
                            </li>
                            <li>
                              <strong>Osobní poradenství:</strong>
                              <p>
                                Konzultace na veletrhu ti umožní získat individuální zpětnou vazbu na tvé CV a LinkedIn profil od odborníků, kteří ti mohou doporučit konkrétní zlepšení.                              </p>
                            </li>
                            <li><strong>Vylepšení profesního profilu:</strong>
                              <p>
                                Odborníci ti pomohou optimalizovat tvůj LinkedIn profil tak, aby byl atraktivní pro potenciální zaměstnavatele a headhuntery.
                              </p>
                            </li>
                            <li>
                              <strong>Praktické tipy:</strong>
                              <p>
                                Získáš konkrétní tipy, jak efektivně prezentovat své dovednosti a zkušenosti, což zvýší tvoje šance na úspěch při hledání práce.
                              </p>
                            </li>
                            <li>
                              <p>
                                Konzultace budou poskytovat přímo zaměstnanci náborových oddělení a HR manažeři zúčastněných firem.
                                Nepropásni tuto jedinečnou příležitost a připrav se na konzultaci v uvedených časech! Kliknutím na firmu o kterou máš zájem se dostaneš na plán veletrhu.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div> 
                      <p className='my-4'>
                      </p>
                    </div>
                  </div>
                </li>
                <li>

                </li>
              </ul>
            </section> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Timeline;
